import moment from "moment";
import { Link } from "react-router-dom";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import { Notification } from "model/notification";
import { deleteNotifications, isHighSeverityNotification } from "services/notifications";
import { useState } from "react";

interface TaskListItemProps {
  item: Notification;
  closeDetails: () => void;
  refresh: () => void;
}

export function NotificationListItem({ item, closeDetails, refresh }: TaskListItemProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteNotification = () => {
    setIsDeleting(true);
    deleteNotifications(
      { notifications: [item.id] },
      () => {
        refresh();
      },
      () => {
        refresh();
      }
    );
  };
  return (
    <div
      className={
        "notification-list-item" + (isHighSeverityNotification(item) ? " overdue" : "")
      }
    >
      <div className="item-header">
        {item.title}
        <span>•</span>
        {moment(item.created_at).fromNow()}
        <button
          className="item-header-close"
          onClick={deleteNotification}
          disabled={isDeleting}
        >
          &#10006;
        </button>
      </div>
      <div className="item-title">{item.message}</div>
      <div className="actions">
        <Link
          className="btn"
          onClick={closeDetails}
          to={TalaeraRoutes.buildTeamMemberDetailsPath(
            item.target_user.team?.id,
            item.target_user.id
          )}
        >
          View Profile
        </Link>
      </div>
    </div>
  );
}
